import React from 'react';

import WrappedBase from './WrappedBase';
import AddMultipleOfferingsToCartButton from '../containers/AddMultipleOfferingsToCartButton';

export default class AddMultipleOfferingsToCartButtonProvided extends React.Component {
  render() {
    return (
      <WrappedBase>
        <AddMultipleOfferingsToCartButton {...this.props} />
      </WrappedBase>
    );
  }
}
